module.exports = __webpack_public_path__ + "svg/new-jcb-big.aacca5ac1dde7841e1febaf4c0aa2463.svg";